module.exports = __webpack_public_path__ + "static/media/articles1.4f77ce7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/articles1.png
// module id = 1224
// module chunks = 0